<template>
  <div>
    <generic-container
      :title="$t('food orders')"
      icon="utensils"
      :show_plus="true"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      v-on:add="add"
    >
      <div class="ui huge center aligned header">{{ $t("pending") }}</div>
    </generic-container>
    <template v-for="(mdl, index) in account_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
// import AccountModal from "./AccountModal";

// @ is an alias to /src
export default {
  name: "AccountsIndex",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      accounts: [],
      configure_modal: ConfigureModal,
      account_modals: [],
    };
  },
  methods: {
    add() {
      // this.account_modals.push(AccountModal);
    },
    succedded(account) {
      let trgtIdx = this.accounts.findIndex((n) => n.uuid == account.uuid);
      if (trgtIdx == -1) {
        this.accounts.push(account);
      } else {
        this.accounts.splice(trgtIdx, 1, account);
      }
    },
    destroy() {
      // this.account_modals = [];
      // this.customer = {};
    },
  },
  created() {},
  mounted() {
    // let vm = this;
  },
  watch: {},
};
</script>
